import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * A service to manage the toggled state of a sidenav
 */
@Injectable({
  providedIn: 'root'
})
export class ToggleSidenavService {
  /** RXJS subject for the state of the sidenav*/
  public isToggled = new Subject<boolean>();

  /**
   * Toggle the sidenav open or closed
   * @param menuState - The boolean state of the sidenav
   */
  public toggleMenu(menuState: boolean) {
    this.isToggled.next(menuState);
  }
}
